import axios from "axios";
import config from "./config";
import store from "../store";
import * as api from "./api";

const service = axios.create(config);
service.interceptors.request.use(
  config => {
    store.index.changeLoading(true);
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  async response => {
    const { data } = response;
    store.index.changeLoading(false);
    return data;
  },
  error => {
    store.index.changeLoading(false);
    return Promise.reject(error);
  }
);

const httpInstance = {
  get(url, params, config) {
    return service.get(url, {
      params,
      ...config
    });
  },
  post(url, params, config) {
    return service.post(url, params, config);
  },
  delete(url, params, config) {
    return service.delete(url, {
      params,
      ...config
    });
  }
};

export default api;
export { httpInstance as http };



// WEBPACK FOOTER //
// ./src/service/index.js